import { ResponseError } from '../../errors';
import {
  IGetProjectsListMetaRequest,
  TGetProjectsListMetaResponse,
  fetchGetProjectsListMeta,
} from '../../repositories/countryside-constructors/v1/get-projects-list-meta';
import { IApplicationContext } from '../../types/applicationContext';
import { EFiltersMetaStatus, IFiltersMeta } from '../../types/filters';

export async function fetchFiltersMeta(
  { httpApi, logger }: IApplicationContext,
  parameters: IGetProjectsListMetaRequest,
): Promise<IFiltersMeta> {
  try {
    const metaData: TGetProjectsListMetaResponse = await fetchGetProjectsListMeta({
      httpApi,
      parameters,
    });

    if (metaData.statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchFiltersMeta',
        message: metaData.response.message || '',
        details: {
          errors: JSON.stringify(metaData.response.errors),
        },
      });
    }

    return {
      data: metaData.response,
      status: EFiltersMetaStatus.Success,
    };
  } catch (error) {
    logger.warning(error);

    return {
      data: { count: 0 },
      status: EFiltersMetaStatus.Fail,
    };
  }
}
